<template>
  <div>
    <div class="application">
      <div class="line showpc" style="height:60px;border-bottom:solid 1px var(--C3);">
        <div class="line-33">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:left;margin-left:15px;">
            <li style="line-height:60px;">
              <img src="../assets/nozay.jpg" alt="" style="height:50px;margin-top:5px;">
            </li>
          </ul>
        </div>
        <div class="line-34">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:center;">
            <li style="line-height:60px;">
              <img src="../assets/7avelo.png" alt="" style="cursor:pointer;height:50px;margin-top:5px;" @click="backAccount">
            </li>
          </ul>
        </div>
        <div class="line-33">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:right;margin-right:15px;">
            <li style="line-height:60px;">
              <login :account="account"></login>
            </li>
          </ul>
        </div>
      </div>
      <div class="line showmobile" style="height:60px;border-bottom:solid 1px var(--C3);">
        <div class="line-50">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:left;margin-left:15px;">
            <li style="line-height:60px;">
              <img src="../assets/nozay.jpg" alt="" style="height:50px;margin-top:5px;" @click="backAccount">
            </li>
          </ul>
        </div>
        <div class="line-50">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:right;margin-right:15px;">
            <li style="line-height:60px;">
              <login :account="account"></login>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="viewdiv=='reservation'">
        <div class="line" style="text-align:center;">      
          <h1>Nouvelle réservation</h1>
          <h3>Effectuez votre réservation en ligne</h3>
        </div>
        <div class="line-a" style="margin-top:40px;margin-bottom:40px;">
          <div v-if="step>=1" class="account-bloc">
              <div class="account-bloc-title">
                <label style="font-size:18px;">Etape 1 / {{maxstep}}</label>
                <p style="color:var(--C2);font-size:13px;padding:0px;margin:0px;">Sélectionnez le type de vélo que vous souhaitez louer</p>
              </div>
              <ul class="family-bloc-text">
                <li v-for="material in list_materials" :key="material.id" @click="validS1(material)">
                  <div class="family-bloc-title">{{material.label}}</div>
                  <div v-if="material.qty>0">
                    <div class="family-bloc-icon"><img :src="'./media/'+material.logo+'.png'" alt="" :class="{'border-bloc-selected' : (material.selected)}" style="height:100px;"></div>
                    <div class="family-bloc-legend">{{material.description}}</div>
                  </div>
                  <div v-if="material.qty<=0 && material.status=='free'">
                    <div class="family-bloc-icon"><img :src="'./media/'+material.logo+'-nb.png'" alt="" :class="{'border-bloc-selected' : (material.selected)}" style="height:100px;"></div>
                    <div class="family-bloc-legend" style="font-weight:bold">Rupture de stock</div>
                  </div>
                  <div v-if="material.qty<=0 && material.status=='locked'">
                    <div class="family-bloc-icon"><img :src="'./media/'+material.logo+'-nb.png'" alt="" :class="{'border-bloc-selected' : (material.selected)}" style="height:100px;"></div>
                    <div class="family-bloc-legend" style="font-weight:bold">réservation limitée</div>
                  </div>
                  <div class="family-bloc-select"></div>
                </li>
              </ul>
          </div>      
        </div>        
        <div v-if="is_no_stock && mat_status=='free'" class="line-a" style="margin-bottom: 20px">
          <div class="account-bloc" style="border-color: red">
            <div class="account-bloc-title">
              Nous n'avons plus de {{ mat_nom }} disponible.<br>
              Veuillez finaliser toutes les étapes afin de vous inscrire sur notre liste d'attente.
            </div>
          </div>
        </div>
        <div v-if="is_no_stock && mat_status=='locked'" class="line-a" style="margin-bottom: 20px">
          <div class="account-bloc" style="border-color: red">
            <div class="account-bloc-title">
              Vous avez atteint le nombre maximum de mois de location possible de {{ mat_nom }}.<br>
              Vous pouvez vous inscrire sur liste d’attente en finalisant les étapes ci -dessous
            </div>
          </div>
        </div>
        <div id="bloc2" v-if="step>=2" class="line-a" style="margin-bottom:40px;">
          <div class="account-bloc">
              <div class="account-bloc-title">
                <label style="font-size:18px;">Etape 2 / {{maxstep}}</label>
                <p style="color:var(--C2);font-size:13px;padding:0px;margin:0px;">Sélectionnez le type d'abonnement</p>
              </div>
              <div v-for="subscription in material_selected.subscriptions" v-bind:key="subscription.id" :class="{'account-bloc-text':true,'bloc-selected' : (subscription.selected==true)}" @click="validS2(subscription)">
                <div class="account-bloc-legend">{{subscription.label}}</div>
                <div class="account-bloc-value" style="font-size:12px;color:var(--C2);">{{subscription.description}}</div>
                <div class="account-bloc-icon">
                  <fa-icon v-if="!(subscription.selected==true)" :icon="['far','circle']" />
                  <fa-icon v-if="(subscription.selected==true)" :icon="['far','check-circle']" />
                </div>
              </div>
          </div>      
        </div>
        <div id="bloc3" v-if="step>=3" class="line-a" style="margin-bottom:40px;">
          <div class="account-bloc">
              <div class="account-bloc-title">
                <label style="font-size:18px;">Etape 3 / {{maxstep}}</label>
                <p style="color:var(--C2);font-size:13px;padding:0px;margin:0px;">Insérer les documents adminitratifs nécessaires pour la location</p>
              </div>
              <div v-if="subscription_selected.id>=1">                
                <div v-if="piece_cni==true" class="account-bloc-text">
                  <div class="account-bloc-legend">CNI / Passeport en cours de validité</div>
                  <div class="account-bloc-value" @click="downloadFile('cni')">Consulter le document</div>
                  <div class="account-bloc-icon"  @click="uploadFile('cni')"><i class='fa fa-upload'></i></div>
                </div>
                <div v-if="piece_cni==false" class="account-bloc-text" @click="uploadFile('cni')">
                  <div class="account-bloc-legend">CNI / Passeport en cours de validité</div>
                  <div class="account-bloc-value" style="color:red;font-weight:bold;"><i class='fa fa-info-circle'></i> Document manquant</div>
                  <div class="account-bloc-icon"><i class='fa fa-chevron-right'></i></div>
                </div>
                <div v-if="piece_justificatif==true" class="account-bloc-text">
                  <div class="account-bloc-legend">Justificatif de domicile de moins de 3 mois</div>
                  <div class="account-bloc-value" @click="downloadFile('justificatif')">Consulter le document</div>
                  <div class="account-bloc-icon"  @click="uploadFile('justificatif')"><i class='fa fa-upload'></i></div>
                </div>
                <div v-if="piece_justificatif==false" class="account-bloc-text" @click="uploadFile('justificatif')">
                  <div class="account-bloc-legend">Justificatif de domicile de moins de 3 mois</div>
                  <div class="account-bloc-value" style="color:red;font-weight:bold;"><i class='fa fa-info-circle'></i> Document manquant</div>
                  <div class="account-bloc-icon"><i class='fa fa-chevron-right'></i></div>
                </div>
              </div>
              <div v-if="subscription_selected.id==2">
                <div v-if="piece_social==true" class="account-bloc-text">
                  <div class="account-bloc-legend">Justificatif Tarif Réduit</div>
                  <div class="account-bloc-value" @click="downloadFile('social')">Consulter le document</div>
                  <div class="account-bloc-icon"  @click="uploadFile('social')"><i class='fa fa-upload'></i></div>
                </div>
                <div v-if="piece_social==false" class="account-bloc-text" @click="uploadFile('social')">
                  <div class="account-bloc-legend">Justificatif Tarif Réduit</div>
                  <div class="account-bloc-value" style="color:red;font-weight:bold;"><i class='fa fa-info-circle'></i> Document manquant</div>
                  <div class="account-bloc-icon"><i class='fa fa-chevron-right'></i></div>
                </div>
              </div>
          </div>      
        </div>
        <div id="bloc4" v-if="step>=4" class="line-a" style="margin-bottom:40px;">
          <div class="account-bloc">
              <div class="account-bloc-title">
                <label style="font-size:18px;">Etape 4 / {{maxstep}}</label>
                <p style="color:var(--C2);font-size:13px;padding:0px;margin:0px;">Sélectionnez la durée de location</p>
              </div>
              <div v-for="pric in subscription_selected.prices" :key="pric.id" :class="{'account-bloc-text':true,'bloc-selected' : (pric.selected==true)}" @click="validS3(pric)">
                <div class="account-bloc-legend">{{pric.label}}</div>
                <div class="account-bloc-value" style="font-size:12px;color:var(--C2);">{{pric.description}}</div>
                <div class="account-bloc-icon" style="text-align:left;padding:20px 20px 20px 0px;"><label style="font-weight:bold;">{{pric.amount|money}}</label></div>
              </div>
          </div>      
        </div>
        <div id="bloc_recap" v-if="visu_payment" class="line-a" style="margin-bottom:40px;">
          <div class="account-bloc">
              <div class="recap-bloc-title">
                <label style="font-size:18px;">Récaptitulatif</label>
                <p style="color:var(--C2);font-size:13px;padding:0px;margin:0px;">Récapitulatif de votre réservation</p>
              </div>
              <div class="recap-bloc-text" style="background-color:var(--C2);color:#fff;border-top:none;">
                <div style="padding:20px;text-align:center;width:calc(100% - 40px);float:left;">
                  <label style="font-size:16px;">{{lbl_description}}</label><br/>
                  <label style="font-size:32px;">{{lbl_amount|money}}</label><br/>                  
                  <!-- <label style="font-size:16px;">Abonnement {{subscription_selected.label}}</label> -->
                  <label v-if="!is_no_stock">Pour un traitement plus rapide de votre dossier, veuillez privilégier le paiement par carte bancaire.</label>
                </div>
              </div>
              <div class="recap-bloc-text" style="background-color:#fff;color:var(--C2);border-top:none;">
                <div style="padding:20px;text-align:center;width:calc(100% - 40px);float:left;">
                  <label v-if="acceptcguv" style="font-size:16px;">
                    <fa-icon :icon="['fas','check-square']"  @click="acceptcguv=(!acceptcguv)" />
                    J'accepte les <a style="color:var(--BUTTON);font-weight:bold;" target="_blank" href="https://7avelo.reservation.cc-nozay.fr/media/7avelo_cgul.pdf">CGUL</a> et la politique de confidentialité
                  </label>
                  <label v-if="!acceptcguv" style="font-size:16px;">
                    <fa-icon :icon="['fas','square']"  @click="acceptcguv=(!acceptcguv)" />
                    J'accepte les <a target="_blank"  style="color:var(--BUTTON);font-weight:bold;" href="https://7avelo.reservation.cc-nozay.fr/media/7avelo_cgul.pdf">CGUL</a> et la politique de confidentialité
                  </label>
                </div>
              </div>              
              <div class="recap-bloc-text" style="padding-top:20px;padding-bottom:20px;text-align:center;width:100%;">
                <div style="padding:10px;text-align:center;width:calc(100% - 20px);float:left;">
                  <button v-if="acceptcguv && is_no_stock==true" @click="goNOSTOCK" class="fbutton fbutton-big" style="margin-right:10px;">Je m'inscris sur liste d'attente</button>
                  <button v-if="acceptcguv && is_no_stock==false" @click="payment_start_agency" class="fbutton fbutton-big" style="margin-right:10px;">Paiement à la signature du contrat</button>
                  <button v-if="!acceptcguv && is_no_stock==false" class="fbutton fbutton-big" style="background-color:var(--C2);margin-right:10px;">Paiement à la signature du contrat</button>
                  <button v-if="acceptcguv && is_no_stock==false" @click="payment_start" class="fbutton fbutton-big">Paiement en ligne (carte bancaire)</button>
                  <button v-if="!acceptcguv && is_no_stock==false" class="fbutton fbutton-big" style="background-color:var(--C2);">Paiement en ligne (carte bancaire)</button>
                </div>
              </div>
          </div>      
        </div>
      </div>
      <div v-if="viewdiv=='retour'">
        <div class="line" style="text-align:center;margin-top:120px;">  
          <i v-if="msgretour=='effectue'" style="color:var(--BUTTON);" class='far fa-smile-beam fa-4x'></i>    
          <i v-if="msgretour!='effectue'" style="color:var(--BUTTON);" class='far fa-frown fa-4x'></i>    
          <h1>{{msgtitle}}</h1>
          <h3>{{msgsubtitle}}</h3>
          <!-- <button v-if="msgretour=='effectue'" style="margin-right:10px;" class='fbutton' @click="goRDV">Prise de RDV</button> -->
          <button class='fbutton' @click="backAccount">Retour à votre compte</button>
        </div>
      </div>
      <div v-if="viewdiv=='nostock'">
        <div class="line" style="text-align:center;margin-top:120px;">  
          <i style="color:var(--BUTTON);" class='far fa-frown fa-4x'></i>    
          <h1>Rupture de stock</h1>
          <h3>Nous n'avons plus de vélo électrique de disponible, veuillez cliquer sur le bouton ci-dessous afin de vous inscrire sur notre liste d'attente.</h3>
          <button style="margin-right:10px;" class='fbutton' @click="goNOSTOCK">S'inscrire sur la liste d'attente</button>
          <button class='fbutton' @click="backAccount">Retour à votre compte</button>
        </div>
      </div>
      <div v-if="viewdiv=='nostock_valid'">
        <div class="line" style="text-align:center;margin-top:120px;">  
          <i style="color:var(--BUTTON);" class='far fa-smile-beam fa-4x'></i>    
          <h1>Inscription dans la liste d'attente</h1>
          <h3>Vous êtes inscrit sur la liste d’attente, un courriel de confirmation vous sera adressé. <br/>Les services de la communauté de communes vous recontacteront dès qu’un vélo sera à nouveau disponible.</h3>
          <button class='fbutton' @click="backAccount">Retour à votre compte</button>
        </div>
      </div>
      <div v-if="viewdiv=='toorental'">
        <div class="line" style="text-align:center;margin-top:120px;">  
          <i style="color:var(--BUTTON);" class='far fa-frown fa-4x'></i>    
          <h1>Vous avez dépassé la durée de location maximum de 12 mois,<br/>Vous ne pouvez donc plus louer de Vélila.</h1>
          <h3>Pour plus d'informations, vous pouvez contacter la communauté de communes de Nozay au 02 40 79 51 51, ou envoyer un mail <a href="mailto:7avelo@cc-nozay.fr">7avelo@cc-nozay.fr</a>.</h3>
          <button class='fbutton' @click="backAccount">Retour à votre compte</button>
        </div>
      </div>
      <div v-if="viewdiv=='toonbrental'">
        <div class="line" style="text-align:center;margin-top:120px;">  
          <i style="color:var(--BUTTON);" class='far fa-frown fa-4x'></i>    
          <h1>Réservation impossible</h1>
          <h3>Vous avez déjà une réservation en cours.</h3>
          <button class='fbutton' @click="backAccount">Retour à votre compte</button>
        </div>
      </div>      
    </div>
    <dataform v-if="JSON.stringify(ctrldataform)!='{}'" :title="ctrldataform.title" :controls="ctrldataform.controls" :fxback="ctrldataform.fxback" :fxsave="ctrldataform.fxsave"></dataform>
    <loadingform v-if="loading"></loadingform>
  </div>
</template>

<script>
import engine from "../core/DataAPI";
import login from "../core/IconLogin";
import dataform from "../core/DataForm";
import loadingform from "../core/LoadingForm";

export default {
  components:{
    login,dataform,loadingform
  },
  data() {
    return {
      loading:false,
      acceptcguv:false,
      msgtitle:'',
      msgsubtitle:'',
      msgretour:'',
      account:{},
      vdate:'',
      viewdiv:'reservation',
      maxstep:5,
      currentstep:1,
      piece_cni:false,
      piece_justificatif:false,
      piece_rib:false,
      piece_social:false,
      piece_attestation:false,
      piece_cni_titulaire:false,
      is_no_stock: false,
      mat_nom: '',
      mat_status:'',
      step:1,
      list_materials:[],
      ctrldataform: {},
      banq_account:{nom:'',prenom:'',adresse:'',cp:'',ville:'',email:'',telephone:'',lien_parente:'',id_fichier:engine.Guid()}
    }
  },
  computed: {
    visu_payment: function(){
      var tmain = this;
      var ret = false;

      if (tmain.step>=5){
        if (tmain.subscription_selected.id==1){
          if (tmain.piece_cni && tmain.piece_justificatif){
            ret = true;
          }
        }
        if (tmain.subscription_selected.id==2){
          if (tmain.piece_cni && tmain.piece_justificatif && tmain.piece_social){
            ret = true;
          }
        }
      }
      return ret;
    },
    material_selected: function(){
      var tmain = this;
      var info = tmain.list_materials.find(x=>x.selected==true);
      if (info==undefined){
        info = {};
      }
      return info;
    },
    subscription_selected: function(){
      var tmain = this;
      var ret = {};
      var mat = tmain.list_materials.find(x=>x.selected==true);
      if (mat!==undefined){
        var infret = mat.subscriptions.find(x=>x.selected==true);
        if (infret !== undefined){
          ret = infret;
        }
      }
      return ret;
    },
    price_selected: function(){
      var tmain = this;
      var ret = {};
      var mat = tmain.list_materials.find(x=>x.selected==true);
      if (mat!==undefined){
        var infsub = mat.subscriptions.find(x=>x.selected==true);
        if (infsub !== undefined){
          var infprice = infsub.prices.find(x=>x.selected==true);
          if (infprice !== undefined){
            ret = infprice;
          }
        }
      }
      return ret;
    },
    lbl_description: function(){      
      var tmain = this;
      var ret = "";
      var mat = tmain.list_materials.find(x=>x.selected==true);
      if (mat!==undefined){
        ret += "1 x " + mat.label + " - ";
      }
      return ret.substring(0,ret.length-3);
    },
    lbl_amount: function(){      
      var tmain = this;
      var ret = 0;
      var mat = tmain.list_materials.find(x=>x.selected==true);
      if (mat!==undefined){
        var infsub = mat.subscriptions.find(x=>x.selected==true);
        if (infsub !== undefined){
          var infprice = infsub.prices.find(x=>x.selected==true);
          if (infprice !== undefined){
            ret += infprice.amount;
          }
        }
      }
      return ret;
    },
    lbl_payment_info_cb: function(){
      var tmain = this;
      var formatter = new Intl.NumberFormat('fr-FR', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2});
      var lbl = formatter.format(tmain.lbl_amount);
      return lbl;
    }
  },
  mounted: function(){
    this.$moment.locale('fr');
  },
  created: function(){
    var tmain = this;
    if (JSON.stringify(tmain.$route.query) != '{}'){
      tmain.refresh_ret(tmain.$route.query);
    }else{
      tmain.refresh_ui();
    }
  },
  methods: {
    refresh_ret: function(params){
      var tmain = this;
      tmain.loading=true;
      tmain.$router.replace({'query':null});
      tmain.viewdiv = 'retour';
      tmain.msgretour = params.state;
      engine.Account_Info(function(pkgauth){
        if (pkgauth.code==-1){
          tmain.$router.push('/');
        }else{
          tmain.account = pkgauth.data[0];
          engine.Material_List(function(pkgm){
            tmain.list_materials = pkgm.data;
            engine.File_Exist('cni',function(pkgcni){
              tmain.piece_cni = pkgcni.data;
              engine.File_Exist('justificatif',function(pkgjust){
                tmain.piece_justificatif = pkgjust.data;
                engine.File_Exist('social',function(pkgsoc){
                  tmain.piece_social = pkgsoc.data;
                  if (params.state=='effectue'){
                    tmain.msgtitle = 'Votre réservation ' + params.resa_number+' a été effectuée avec succès.';
                    tmain.msgsubtitle = 'Un courriel vous a été envoyé afin de finaliser votre réservation.';
                    tmain.loading=false;                                                      
                  }else{
                    tmain.msgtitle = 'Votre réservation a rencontré une erreur.';
                    tmain.msgsubtitle = 'Veuillez contacter Vélila par e-mail au 7avelo@cc-nozay.fr';
                    tmain.loading=false;
                  }
                })
              })
            })
          })
        }
      });
    },
    refresh_ui: function(){
      var tmain = this;
      tmain.loading=true;
      engine.Account_Info(function(pkg){
        if (pkg.code!=0){
          tmain.$router.push('/');
        }else{
          tmain.account = pkg.data[0];
          if (tmain.account.web_nb_reservation!=0){
            tmain.loading = false;
            tmain.viewdiv = "toonbrental";
          }else{
            engine.Material_List(function(pkgm){
              tmain.list_materials = pkgm.data;
              tmain.loading=false;
              var current_stock = 0;

              tmain.list_materials.forEach(mat => {
                if (mat.qty>0){
                 current_stock += mat.qty;
                }
              });
              if(current_stock<=0){
                tmain.is_no_stock = true;
                //tmain.viewdiv = "nostock";
              }
              if (tmain.list_materials[0].subscriptions[0].prices.length==0 && tmain.list_materials[1].subscriptions[0].prices.length==0 ){
                tmain.viewdiv = "toorental";
              }
            });
            engine.File_Exist('cni',function(pkgp1){
              tmain.piece_cni = pkgp1.data;
            });
            engine.File_Exist('justificatif',function(pkgp2){
              tmain.piece_justificatif = pkgp2.data;
            });
            engine.File_Exist('social',function(pkgp4){
              tmain.piece_social = pkgp4.data;
            });
          }      
        }
      });
    },
    refresh_docs: function(){
      var tmain = this;
      engine.File_Exist('cni',function(pkgp1){
        tmain.piece_cni = pkgp1.data;
        engine.File_Exist('justificatif',function(pkgp2){
          tmain.piece_justificatif = pkgp2.data;
          engine.File_Exist('social',function(pkgp4){
            tmain.piece_social = pkgp4.data;
            var options = {
                container: '.application',
                easing: 'ease-out',
                offset: -10,
                force: true,
                cancelable: true,
                x: false,
                y: true
            };
            if (tmain.subscription_selected.id==1){
              if (tmain.piece_cni && tmain.piece_justificatif){
                tmain.step=4;
                setTimeout(function(){tmain.$scrollTo("#bloc4",500,options);},100);
              }else{
                tmain.step=3;
              }
            }
            if (tmain.subscription_selected.id==2){
              if (tmain.piece_cni && tmain.piece_justificatif && tmain.piece_social){
                tmain.step=4;
                setTimeout(function(){tmain.$scrollTo("#bloc4",500,options);},100); 
              }else{
                tmain.step=3;
              }
            }
          });
        });
      });
    },
    validS1: function(mat){
      var tmain = this;         
      //if (mat.qty>0){
        tmain.list_materials.forEach(m=> {m.selected=false;});
        mat.selected = true;
        tmain.mat_nom = mat.label;
        if(mat.qty <= 0){
          tmain.is_no_stock = true;
        }else{
          tmain.is_no_stock = false;          
        }
        tmain.mat_status = mat.status;
        var options = {
          container: '.application',
          easing: 'ease-out',
          offset: -10,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };
        tmain.step = 2;        
        setTimeout(function(){tmain.$scrollTo("#bloc2",500,options);},100);        
      //}   
    },
    validS2: function(subs){
      var tmain = this;
      tmain.material_selected.subscriptions.forEach(s=>s.selected=false);
      subs.selected=true;
      tmain.subscription_selected.prices.forEach(s=>s.selected=false);
            
      var options = {
        container: '.application',
        easing: 'ease-out',
        offset: -10,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      tmain.step = 3;
      setTimeout(function(){tmain.$scrollTo("#bloc3",500,options);tmain.refresh_docs();},100);
    },
    validS3: function(p){
      var tmain = this;
      tmain.subscription_selected.prices.forEach(s=>s.selected=false);
      p.selected=true;
      var options = {
        container: '.application',
        easing: 'ease-out',
        offset: -10,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      tmain.step = 5;
      setTimeout(function(){tmain.$scrollTo("#bloc_recap",500,options);},100);
    },
    downloadFile:function(doctype){
      var tmain = this;
      if (doctype=="attestation"){doctype=tmain.banq_account.id_fichier;}
      engine.File_Download(doctype,function(pkgfile){
        var ctype = pkgfile.headers.map["content-type"];
        var extname = ".pdf";
        if (ctype[0]=="image/png"){extname=".png";}
        if (ctype[0]=="image/jpg"){extname=".jpg";}
        if (ctype[0]=="image/jpeg"){extname=".jpeg";}
        var fileURL = window.URL.createObjectURL(new Blob([pkgfile.data]));
        var download_link = document.createElement('a');
        download_link.href = fileURL;
        download_link.download = doctype + extname;
        download_link.target = "_blank";
        document.body.appendChild(download_link);
        download_link.click();
        document.body.removeChild(download_link);
      });
    },
    uploadFile: function(doctype){
      var tmain = this;
      tmain.account.file_cni = "";
      tmain.account.file_cni_titulaire = "";
      tmain.account.file_justificatif = "";
      tmain.account.file_rib = "";
      tmain.account.file_social = "";
      tmain.account.file_attestation = "";

      if (doctype=="cni"){
        tmain.ctrldataform = { 
          title:"Envoyer des pièces justificatives",
          controls:[
            {datatype:'file',databind:'file_cni',description:'CNI / Passeport (au format PDF ou image)',condvalue:false,condmsg:'Le fichier doit être au format PDF ou image avec une taille < 5 Mo',condfx:function(val){return (val.size < 5242880 && (val.type=="application/pdf" || val.type.indexOf('png')>-1 || val.type.indexOf('jpg')>-1 || val.type.indexOf('jpeg')>-1)); }}
          ],
          fxback:function(){
            tmain.ctrldataform={};
          },
          fxsave:function(ctrl){
            engine.File_Upload(ctrl.file_cni,'cni',function(){
              tmain.ctrldataform={};
              tmain.refresh_docs();
            });          
          }
        };
      }
      if (doctype=="justificatif"){
        tmain.ctrldataform = { 
          title:"Envoyer des pièces justificatives",
          controls:[
            {datatype:'file',databind:'file_justificatif',description:'Justificatif de domicile (au format PDF ou image)',condvalue:false,condmsg:'Le fichier doit être au format PDF ou image avec une taille < 5 Mo',condfx:function(val){return (val.size < 5242880 && (val.type=="application/pdf" || val.type.indexOf('png')>-1 || val.type.indexOf('jpg')>-1 || val.type.indexOf('jpeg')>-1)); }}
          ],
          fxback:function(){
            tmain.ctrldataform={};
          },
          fxsave:function(ctrl){
            engine.File_Upload(ctrl.file_justificatif,'justificatif',function(){
              tmain.ctrldataform={};
              tmain.refresh_docs();
            });          
          }
        };
      }
      if (doctype=="social"){
        tmain.ctrldataform = { 
          title:"Envoyer des pièces justificatives",
          controls:[
            {datatype:'file',databind:'file_social',description:'Justificatif Tarif Réduit (au format PDF ou image)',condvalue:false,condmsg:'Le fichier doit être au format PDF ou image avec une taille < 5 Mo',condfx:function(val){return (val.size < 5242880 && (val.type=="application/pdf" || val.type.indexOf('png')>-1 || val.type.indexOf('jpg')>-1 || val.type.indexOf('jpeg')>-1)); }}
          ],
          fxback:function(){
            tmain.ctrldataform={};
          },
          fxsave:function(ctrl){
            engine.File_Upload(ctrl.file_social,'social',function(){
              tmain.ctrldataform={};
              tmain.refresh_docs();
            });          
          }
        };
      }
    },
    payment_start: function(){
      var tmain = this;
      tmain.loading = true;
      var pkgp = {
        materials:tmain.list_materials,
        options:{
          is_main_bank:tmain.account.is_main_bank,
          banq_account:tmain.banq_account,
          amount:tmain.lbl_amount
        }
      };
      engine.Reservation_Create(pkgp,function(pkgcreate){
        var datenow = tmain.$moment().format('YYYY');
        var amount = (tmain.lbl_amount*100);
        var reference = pkgcreate.data;
        //var reference = 'RSW-TEST01-'+tmain.$moment().format('HHmm');
        var mail = tmain.account.email;
        engine.Payfip_Create(
          datenow,
          mail,
          amount,
          'Reservation',
          reference,
          'https://7avelo.reservation.cc-nozay.fr/api/payfip/validate',
          'https://7avelo.reservation.cc-nozay.fr/api/payfip/validate',
          function(pkgr){
            tmain.loading = false;
            var download_link = document.createElement('a');
            download_link.href = pkgr.data;
            //download_link.target = "_blank";
            document.body.appendChild(download_link);
            download_link.click();
            document.body.removeChild(download_link);
          }
        );
      });
    },
    payment_start_agency: function(){
      var tmain = this;
      tmain.loading = true;
      var pkgp = {
        materials:tmain.list_materials,
        options:{
          is_main_bank:tmain.account.is_main_bank,
          banq_account:tmain.banq_account,
          amount:tmain.lbl_amount
        }
      };
      engine.Reservation_Create(pkgp,function(pkgcreate){        
        var reference = pkgcreate.data;
        engine.Reservation_Validate(reference,function(pkgvalid){
          tmain.loading = false;
          if (pkgvalid.code==0){
            tmain.msgretour = 'effectue';
            tmain.msgtitle = 'Votre réservation ' + reference+' a été effectuée avec succès.';
            tmain.msgsubtitle = 'Un courriel vous a été envoyé afin de finaliser votre réservation.';
            tmain.viewdiv = "retour";
          }
        });
      });
    },
    backAccount:function(){
      var tmain = this;
      tmain.$router.push('/board');
    },
    goRDV: function(){
      var download_link = document.createElement('a');
      download_link.href = "https://www.cc-nozay.fr";
      download_link.target = "_blank";
      document.body.appendChild(download_link);
      download_link.click();
      document.body.removeChild(download_link);
    },
    goNOSTOCK: function(){
      var tmain = this;
      engine.Reservation_Nostock(tmain.mat_nom,tmain.mat_status,function(){
        tmain.viewdiv = "nostock_valid";
      });
    }
  }
}
</script>
<style>
</style>
